<template>
  <div class="containerConsultantBooking">
    <section class="section">
      <div class="container">
        <div class="booking_modal_wrapper">
          <h1 class="modal_title">Book Consultant Form</h1>
          <div class="booking_steps">
            <div class="booking_step">
              <p class="booking_step_count active_count">1</p>
              <p class="step_desc active_desc">Pick a time</p>
            </div>
            <div class="booking_step">
              <p class="booking_step_count">2</p>
              <p class="step_desc">Duration</p>
            </div>
            <div class="booking_step">
              <p class="booking_step_count">3</p>
              <p class="step_desc">Payment</p>
            </div>
            <div class="booking_step">
              <p class="booking_step_count">4</p>
              <p class="step_desc">Confirmation</p>
            </div>
          </div>

          <div class="cr_schedule">
            <div class="cr_calender">
              <h3>Select date</h3>
              <div id="myCalendar" class="vanilla-calendar"></div>
            </div>
            <div class="cr_availability">
              <div class="select_times">
                <h3>Select time</h3>
                <ul class="multi-checkbox">
                  <li>
                    <label>
                      <input type="checkbox" value="6:00PM" checked />
                      <span>6:00PM</span>
                    </label>
                  </li>
                  <li>
                    <label>
                      <input type="checkbox" value="7:00PM" />
                      <span>7:00PM</span>
                    </label>
                  </li>
                  <li>
                    <label>
                      <input type="checkbox" value="8:00PM" />
                      <span>8:00PM</span>
                    </label>
                  </li>
                  <li>
                    <label>
                      <input type="checkbox" value="9:00PM" />
                      <span>9:00PM</span>
                    </label>
                  </li>
                  <li>
                    <label>
                      <input type="checkbox" value="9:00PM" />
                      <span>9:00PM</span>
                    </label>
                  </li>

                  <li>
                    <label>
                      <input type="checkbox" value="9:00PM" />
                      <span>9:00PM</span>
                    </label>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <p class="booking_action">
            <a href>Set a duration</a>
          </p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
// import VanillaCalendar from "../../assets/js/libs/vanilla-calendar";
export default {
  // new VanillaCalendar({
  //   selector: "#myCalendar",
  //   availableWeekDays: [{ day: 1 }, { day: 2 }, { day: 1 }],
  //   availableDates: [{ date: "2020-01-15" }],
  //   datesFilter: true,
  //   pastDates: false
  // })
};
</script>
